import api from './api';

const settingsService = {
  // Get settings dashboard data
  getDashboardData: async () => {
    try {
      const response = await api.get('/users/dashboard');
      return response.data;
    } catch (error) {
      console.error('Error fetching settings dashboard data:', error);
      throw error;
    }
  },

  // Export users to Excel (placeholder for future implementation)
  exportUsersToExcel: async () => {
    try {
      const response = await api.get('/users/export/excel', {
        responseType: 'blob'
      });
      
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'users-export.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting users:', error);
      throw error;
    }
  }
};

export default settingsService;
